import { CaseVoucherTags } from '../index.js';
import { VoucherCategory, VoucherTypeIds, VoucherTypeSetting } from './index.js';
export const CollectionComissionVoucherTypes = [
    VoucherTypeIds.COLLECTIONCOMMISSION,
    VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT,
    VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE,
];
export const RegularFeeVoucherTypes = [
    VoucherTypeIds.ENDCASEFEE,
    VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE,
    VoucherTypeIds.BPKFEE,
    VoucherTypeIds.FOLKEREGISTEROPSLAG,
    VoucherTypeIds.ANMELDELSEAFKRAV,
    VoucherTypeIds.FOGEDFEE,
    VoucherTypeIds.JURIDISKBISTAND,
    VoucherTypeIds.STARTCASEFEE,
    VoucherTypeIds.BERAMMELSESAFGIFT, // TODO: Voucher type category is disbursement
    VoucherTypeIds.AFLYSNINGAFUDLAEG,
    VoucherTypeIds.LOCKSMITHFEE,
    VoucherTypeIds.DRIVINGFEE,
    VoucherTypeIds.OTHERFEE,
];
export const FeeVoucherTypes = [
    ...CollectionComissionVoucherTypes,
    ...RegularFeeVoucherTypes,
];
export const DisbursementVoucherTypes = [
    VoucherTypeIds.BPKDISBURSEMENT,
    VoucherTypeIds.FOGEDDISBURSEMENT,
    VoucherTypeIds.POLICEDISBURSEMENT,
    VoucherTypeIds.STAEVNINGSGEBYR,
    VoucherTypeIds.BERAMMELSESAFGIFT,
];
export const CaseVoucherCategories = [
    VoucherCategory.TRANSACTION,
    VoucherCategory.PRINCIPAL,
    VoucherCategory.COST,
    VoucherCategory.COURTCOST,
    VoucherCategory.INTEREST,
];
export const OrderedCaseVoucherCategories = [
    VoucherCategory.PRINCIPAL,
    VoucherCategory.COST,
    VoucherCategory.COURTCOST,
    VoucherCategory.INTEREST,
    VoucherCategory.TRANSACTION,
];
// Debt with a limitation period of its own
export const ExpiringVoucherCategories = [
    VoucherCategory.PRINCIPAL,
    VoucherCategory.COST,
    VoucherCategory.COURTCOST,
    VoucherCategory.INTEREST,
];
export const DebtorImposedBy = [
    CaseVoucherTags.IMPOSEDBYCREDITOR,
    CaseVoucherTags.IMPOSEDBYCOLLECTOR,
];
export const CaseVoucherInterestSettings = [
    VoucherTypeSetting.CompoundInterest,
    VoucherTypeSetting.InterestFromTable,
    VoucherTypeSetting.InterestPercentage,
];
// Interest the engine calculates, as opposed to interest booked as an amount.
export const isCalculatedInterest = (voucher) => voucher.setting != null &&
    CaseVoucherInterestSettings.includes(voucher.setting);
//# sourceMappingURL=setup.js.map